import {useParams} from "react-router-dom";
import {ALL_TOPIC_TYPES} from "../../paths";

interface ContentParams {
    resourceId: string | undefined;
    dokumentName: string | undefined;
    dokumentId: string | undefined;
    collectionId: string | undefined;
    topicType: string | undefined;
    topicName: string | undefined;
    segmentId: string | undefined;
    isValidTopicType: boolean;
    isPreview: boolean;
}

export function useContentParams(): ContentParams {
    const params = useParams<{
        topicType?: string;
        topicName?: string;
        topicId: string;
        dokumentName?: string;
        dokumentId?: string;
        segmentId?: string;
        collectionId?: string;
    }>();

    const topicType = params.topicType;
    const isValidTopicType =
        topicType !== undefined && (ALL_TOPIC_TYPES as Set<string>).has(topicType.toLowerCase());

    // "preview" mode: no topicType segment, just a bare topicId
    const isPreview = topicType === undefined && params.topicId !== undefined;

    return {
        resourceId: params.topicId,
        dokumentName: params.dokumentName,
        dokumentId: params.dokumentId,
        collectionId: params.collectionId,
        topicType,
        topicName: params.topicName,
        segmentId: params.segmentId,
        isValidTopicType,
        isPreview,
    };
}
